var _rect, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.4443,
    width: 15.5556,
    height: 11.6454,
    rx: 1,
    fill: "url(#paint0_linear_41_2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1483,
    y: 4.65829,
    width: 19.7037,
    height: 17.4681,
    rx: 1,
    fill: "url(#paint1_linear_41_2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1483,
    y: 26.7842,
    width: 23.8518,
    height: 26.7843,
    rx: 2,
    fill: "url(#paint2_linear_41_2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.33334,
    y: 41.924,
    width: 18.6667,
    height: 17.4681,
    rx: 1,
    fill: "url(#paint3_linear_41_2)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 16.3034,
    width: 28,
    height: 22.1262,
    rx: 1,
    fill: "url(#paint4_linear_41_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41_2",
    x1: 20.222,
    y1: 0,
    x2: 20.222,
    y2: 11.6454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C12D2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_41_2",
    x1: 42.0001,
    y1: 4.65829,
    x2: 42.0001,
    y2: 22.1263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C12D2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_41_2",
    x1: 44.0742,
    y1: 26.7842,
    x2: 44.0742,
    y2: 53.5686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C12D2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_41_2",
    x1: 18.6667,
    y1: 41.924,
    x2: 18.6667,
    y2: 59.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C12D2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_41_2",
    x1: 14,
    y1: 16.3034,
    x2: 14,
    y2: 38.4296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4E50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C12D2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bfc32458a914a0298e62996bedf3286a.svg";
export { ForwardRef as ReactComponent };